var heartbeat;

heartbeat = {

	init: function() {
		var modal;

		this.getModal = function() {
			if ( ! modal ) {
				modal = this.initModal();
			}

			return modal;
		};

		Backbone.$( document ).on( {
			'heartbeat-send': function( event, data ) {
				data.kitbuilder_post_lock = {
					post_ID: kitbuilder.config.post_id
				};
			},
			'heartbeat-tick': function( event, response ) {
				if ( response.locked_user ) {
					if ( kitbuilder.isEditorChanged() ) {
						kitbuilder.saveEditor( { status: 'autosave' } );
					}

					heartbeat.showLockMessage( response.locked_user );
				} else {
					heartbeat.getModal().hide();
				}

				kitbuilder.config.nonce = response.kitbuilder_nonce;
			}
		} );

		if ( kitbuilder.config.locked_user ) {
			heartbeat.showLockMessage( kitbuilder.config.locked_user );
		}
	},

	initModal: function() {
		var modal = kitbuilder.dialogsManager.createWidget( 'options', {
			headerMessage: kitbuilder.translate( 'take_over' )
		} );

		modal.addButton( {
			name: 'go_back',
			text: kitbuilder.translate( 'go_back' ),
			callback: function() {
				parent.history.go( -1 );
			}
		} );

		modal.addButton( {
			name: 'take_over',
			text: kitbuilder.translate( 'take_over' ),
			callback: function() {
				wp.heartbeat.enqueue( 'kitbuilder_force_post_lock', true );
				wp.heartbeat.connectNow();
			}
		} );

		return modal;
	},

	showLockMessage: function( lockedUser ) {
		var modal = heartbeat.getModal();

		modal
			.setMessage( kitbuilder.translate( 'dialog_user_taken_over', [ lockedUser ] ) )
		    .show();
	}
};

module.exports = heartbeat;
